import { Fragment } from "react";
import style from "./buy_step.module.css";

export default function BuySteps() {
  const buyStep = [
    {
      id: 1,
      title: "ค้นหาตำแหน่งบ้านเพื่อเช็กความเสี่ยง",
      description: "ระบุตำแหน่งพื้นที่บ้านคร่าวๆ ก็สามารถเช็กความเสี่ยงและเลือกความคุ้มครองที่คุณต้องการได้"
    },
    {
      id: 2,
      title: "คำนวณเบี้ยประกัน",
      description: "เพียงระบุขนาด ประเภทบ้าน ระบบจะคำนวณเบี้ยประกันที่เหมาะสมเฉพาะบ้านคุณ"
    },
    {
      id: 3,
      title: "เปรียบเทียบแผนประกัน",
      description: "เปรียบเทียบราคาและความคุ้มครองเพื่อเลือกแผนที่ใช่"
    },
    {
      id: 4,
      title: "ชำระเงิน",
      description: "ชำระได้หลายช่องทางทั้งบัตรเดบิต เครดิต และคิวอาร์โค้ด"
    },
    {
      id: 5,
      title: "รับกรมธรรม์",
      description: "เลือกช่องทางการรับกรมธรรม์ได้ทางอีเมลและไปรษณีย์"
    },
  ];

  return (
    <div className={style.buy_steps}>
      <Fragment>
        <div className={style.title}>
          <h2>5 ขั้นตอนซื้อประกันบ้านออนไลน์ด้วยตนเอง</h2>
        </div>
        <div className={style.buy_step_items}>
          <ul className={style.buy_step_items_container}>
            {buyStep.map((step, index) => (
              <li className={style.buy_step} key={index}>
                <div className={style.buy_step_heading}>
                  <h2>0{step.id}</h2>
                </div>
                <div className={style.buy_step_details}>
                  <p className={style.buy_step_details_title}>{step.title}</p>
                  <p className={style.buy_step_details_description}>{step.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Fragment>
    </div>
  );
}
